var _g, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGroup5(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_2761_3714)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 21,
    cy: 21,
    r: 21,
    fill: "#062C5B"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.439 16.2608L14.089 12.9108L12.9107 14.0891L27.9107 29.0891L29.089 27.9108L27.4057 26.2274C28.6549 24.7729 29.3388 22.9173 29.3323 20.9999C29.3323 17.5908 27.2723 14.7891 24.3332 13.4999V15.1666C26.3223 16.3216 27.6657 18.5391 27.6657 20.9999C27.6614 22.4804 27.1723 23.9188 26.2732 25.0949L25.2015 24.0233C25.7032 23.1133 25.9998 21.9916 25.9998 20.9999C25.9998 19.5241 25.354 17.7499 24.3332 16.8333V23.1549L22.6665 21.4883V12.7766L17.439 16.2608ZM14.3332 25.1666H16.5807L22.6665 29.2233V26.1008L13.5848 17.0191C13.3097 17.1568 13.0783 17.3681 12.9161 17.6296C12.754 17.891 12.6676 18.1923 12.6665 18.4999V23.4999C12.6665 24.4191 13.414 25.1666 14.3332 25.1666Z",
    fill: "#4C7EBD"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_2761_3714",
    x: -4,
    y: -4,
    width: 50,
    height: 50,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_2761_3714"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_2761_3714",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup5);
export default __webpack_public_path__ + "static/media/Group5.8f54f93e398686d162702e8b6b09e7d8.svg";
export { ForwardRef as ReactComponent };